import { decodeJwtPayload } from "./jwt";
export function can(role: "builder" | "ops" | "steward", token?: string | null) {
  const p = decodeJwtPayload<any>(token || JSON.parse(localStorage.getItem("dc.auth")||"null")?.token);
  const roles = Array.isArray(p?.roles) ? p.roles :
    typeof p?.role === "string" ? [p.role] :
    typeof p?.scope === "string" ? p.scope.split(/\s+/) : [];
  return roles.includes(role);
}


